import { Nullable } from '@clearverify/types';

import { useCheckIsAdditionalVerifierAdminLazyQuery } from 'src/api';

export const useCheckIsAdditionalVerifierAdmin = (verifierId: Nullable<string>) => {
  return useCheckIsAdditionalVerifierAdminLazyQuery({
    variables: {
      verifierId: verifierId ?? '',
    },
    fetchPolicy: 'network-only',
  });
};
